export default (props) => (
  <svg
    width="162"
    height="45"
    viewBox="0 0 162 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    {...props}
  >
    <g clipPath="url(#clip0_3806_16050)">
      <path
        opacity="0.35"
        d="M17.7577 9.68479L0.623132 26.9294C0.560824 26.9916 0.436209 27.1161 0.373901 27.1784C0.560824 26.9294 0.810055 26.8049 1.05929 26.6803L18.4431 16.097C19.3777 15.4745 20.6862 15.7858 21.247 16.7818C21.4339 17.0931 21.5585 17.4666 21.5585 17.8402V11.1789C21.5585 9.93381 20.5616 8.93774 19.3154 8.99999C18.7547 8.99999 18.1939 9.24901 17.7577 9.68479Z"
        fill="#1D1F21"
      />
      <path
        d="M21.6209 24.6259V28.548C21.6209 29.6686 20.6862 30.6024 19.5647 30.6024H2.11855C-0.311446 30.6024 -0.7476 27.1161 1.49548 26.5558L18.9416 22.6338C20.0632 22.2603 21.247 22.8828 21.5586 24.0034C21.5586 24.1902 21.6209 24.4392 21.6209 24.6259Z"
        fill="#1D1F21"
      />
      <path
        opacity="0.75"
        d="M18.5053 16.097L1.12146 26.6803C1.24608 26.6181 1.37069 26.6181 1.49531 26.5558L17.0722 23.0696L18.9415 22.6338C20.063 22.3225 21.2468 22.9451 21.5584 24.0034C21.6207 24.1902 21.6207 24.3769 21.6207 24.5637V17.8402C21.6207 16.7196 20.7484 15.7858 19.6268 15.7858C19.1907 15.7858 18.8168 15.9103 18.5053 16.097Z"
        fill="#1D1F21"
      />
      <path
        d="M54.27 13.7936H60.75C61.56 13.7936 62.37 13.8559 63.18 14.0426C63.9277 14.1671 64.6131 14.4784 65.2362 14.8519C65.7969 15.2255 66.2954 15.7858 66.6069 16.4083C66.9808 17.1554 67.1677 18.0269 67.1054 18.8362C67.1054 19.8946 66.7939 21.0152 66.1708 21.8867C65.4854 22.7583 64.5508 23.3186 63.4916 23.4431L67.7285 30.5401H63.3046L59.8154 23.8789H58.0085V30.6024H54.3323V13.7936H54.27ZM58.0085 20.7039H60.1892C60.5008 20.7039 60.8746 20.7039 61.2485 20.6416C61.6223 20.6416 61.9339 20.5794 62.2454 20.4549C62.5569 20.3304 62.8062 20.1436 62.9931 19.8946C63.2423 19.5833 63.3046 19.2098 63.3046 18.8362C63.3046 18.4627 63.2423 18.1514 63.0554 17.8402C62.8685 17.5911 62.6816 17.4044 62.37 17.2799C62.0585 17.1554 61.7469 17.0309 61.4354 17.0309C61.1239 16.9686 60.75 16.9686 60.3762 16.9686H57.9462V20.7039H58.0085Z"
        fill="#1D1F21"
      />
      <path
        d="M44.4877 20.7039V26.7426C44.0515 26.9916 43.553 27.1784 43.1169 27.3029C42.4315 27.4897 41.7461 27.6142 41.0607 27.5519C40.313 27.5519 39.5654 27.4274 38.88 27.1161C38.2569 26.8671 37.6961 26.4936 37.26 25.9956C36.8238 25.4975 36.45 24.9372 36.2007 24.2524C35.7023 22.8206 35.7023 21.3265 36.2007 19.8946C36.45 19.272 36.8238 18.7118 37.26 18.2137C37.6961 17.7157 38.2569 17.3422 38.9423 17.0931C39.6277 16.8441 40.3754 16.6573 41.123 16.7196C41.933 16.7196 42.7431 16.8441 43.4907 17.0931C44.1138 17.3422 44.7369 17.7779 45.173 18.276L47.79 15.4123C46.9177 14.6029 45.9207 14.0426 44.7369 13.7314C43.4907 13.4201 42.2446 13.2333 40.9984 13.2333C39.7523 13.2333 38.5061 13.4201 37.3846 13.8559C36.3254 14.2294 35.3284 14.852 34.5184 15.599C33.7084 16.4083 33.0854 17.3422 32.6492 18.4005C31.7146 20.7662 31.7146 23.3809 32.6492 25.7465C33.0854 26.8049 33.7084 27.7387 34.5184 28.548C35.3284 29.3573 36.3254 29.9176 37.3846 30.2911C38.5684 30.7269 39.7523 30.9137 40.9984 30.9137C42.2446 30.9137 43.4284 30.7892 44.6123 30.5402C45.7961 30.2911 46.98 29.8554 48.0392 29.2951V20.7039H44.4877Z"
        fill="#1D1F21"
      />
      <path
        d="M72.5885 13.7936H76.2647V30.6024H72.5885V13.7936Z"
        fill="#1D1F21"
      />
      <path
        d="M82.6823 13.7936H88.2276C89.5361 13.7936 90.7823 13.9181 92.0907 14.2294C93.2123 14.4784 94.3338 14.9764 95.2684 15.6613C96.203 16.3461 96.9507 17.2176 97.3869 18.276C97.9476 19.521 98.1969 20.8284 98.1969 22.198C98.1969 23.4431 97.9476 24.6882 97.4492 25.8088C96.9507 26.8049 96.2653 27.7387 95.393 28.4235C94.5207 29.1705 93.4615 29.6686 92.3399 30.0421C91.1561 30.4156 89.9722 30.6024 88.7261 30.6024H82.6823V13.7936ZM86.4207 27.1784H88.3523C89.1623 27.1784 89.9723 27.1161 90.7199 26.9294C91.4053 26.8049 92.0907 26.4936 92.6515 26.0578C93.2123 25.622 93.6484 25.124 93.8976 24.5014C94.2092 23.7544 94.3961 22.9451 94.3338 22.0735C94.3338 21.3264 94.2092 20.6416 93.8353 19.9568C93.5238 19.3343 93.0876 18.8362 92.5892 18.4627C92.0284 18.0269 91.4053 17.7779 90.7199 17.5912C89.9723 17.4044 89.2246 17.2799 88.4769 17.2799H86.2961L86.4207 27.1784Z"
        fill="#1D1F21"
      />
      <path
        d="M103.805 13.7936H107.481V27.1784H114.335V30.6024H103.742L103.805 13.7936Z"
        fill="#1D1F21"
      />
      <path
        d="M119.382 13.7936H123.058V30.6024H119.382V13.7936Z"
        fill="#1D1F21"
      />
      <path
        d="M129.413 13.7936H134.46L141.625 25.4975H141.688V13.7936H145.364V30.6024H140.504L133.151 18.6495H133.089V30.6024H129.413V13.7936Z"
        fill="#1D1F21"
      />
      <path
        d="M154.585 17.2176H162V13.7936H150.909V30.6024H162V27.1784H154.585V23.8789H158.012V20.4549H154.585V17.2176Z"
        fill="#1D1F21"
      />
    </g>
    <defs>
      <clipPath id="clip0_3806_16050">
        <rect
          width="162"
          height="22.0382"
          fill="white"
          transform="translate(0 9)"
        />
      </clipPath>
    </defs>
  </svg>
)
